<template>
    <div id="about-page">
        <app-flex-header></app-flex-header>
        <section  v-if="items.page" class="hero is-default animated">
            <div class="hero-body">
                <h1 class="title mt-80 down-line wide">{{ items.page.name }}</h1>
            </div>
        </section>
        <section  v-if="items.page" class="section about">
            <div v-html="items.page.description"></div>
        </section>
        <app-action-call-general  v-if="items.quote" :quote="items.quote"></app-action-call-general>
        <app-action-call-footer  v-if="items.post" :post="items.post"></app-action-call-footer>
    </div>
</template>

<script>
import { ApiHome, PhotoUrl } from '../.env';
import { mapGetters, mapActions } from 'vuex';
import FlexHeaderBar from '../components/layout/FlexHeaderBar';
import CaGeneral from '../components/complex/CaGeneral';
import CaFooter from '../components/complex/CaFooter';

export default {
    data() {
        return {
            endpoint: ApiHome + 'about',
        }
    },

    components: {
        'app-flex-header': FlexHeaderBar,
        'app-action-call-general': CaGeneral,
        'app-action-call-footer': CaFooter,
    },

    computed: {
        ...mapGetters([
            'items',
            'error',
            'loading',
            'title'
        ]),
    },

    methods: {
        fetchAbout() {
            this.$store.dispatch('fetchItems', this.endpoint);
        },
    },

    mounted() {
        this.fetchAbout();
        // console.log('About - Component mounted.')
    }
}
</script>



// WEBPACK FOOTER //
// src/views/About.vue